module.exports = __webpack_public_path__ + "static/media/placeholderIcon.afd7da95.svg";